import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCultures } from '../api/api';
import './Cultures.css';

const Cultures = () => {
  const [cultures, setCultures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredCultures, setFilteredCultures] = useState([]);

  useEffect(() => {
    fetchCultures();
  }, []);

  useEffect(() => {
    if (searchQuery.trim() === '') {
      setFilteredCultures(cultures);
    } else {
      const filtered = cultures.filter(culture =>
        (culture.displayName || culture.cultureName).toLowerCase().includes(searchQuery.toLowerCase()) ||
        (culture.overview && culture.overview.toLowerCase().includes(searchQuery.toLowerCase()))
      );
      setFilteredCultures(filtered);
    }
  }, [searchQuery, cultures]);

  const fetchCultures = async () => {
    try {
      const response = await getCultures({ verified: true });
      // Backend returns { cultures: [...], pagination: {...} }
      const culturesData = response.data.cultures || [];
      setCultures(culturesData);
      setFilteredCultures(culturesData);
      setLoading(false);
    } catch (err) {
      setError('Failed to load cultural information');
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading cultural information...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="cultures-page">
      <div className="cultures-header">
        <h1>South African Cultures</h1>
        <p className="subtitle">
          Explore the rich diversity of South Africa's cultural heritage
        </p>
      </div>

      <div className="search-section">
        <input
          type="text"
          placeholder="Search cultures..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="cultures-grid">
        {filteredCultures.length > 0 ? (
          filteredCultures.map((culture) => (
            <Link
              to={`/cultures/${culture.cultureName}`}
              key={culture._id}
              className="culture-card"
            >
              <div className="culture-card-header">
                <h2>{culture.displayName || culture.cultureName}</h2>
              </div>
              {culture.alternativeNames && culture.alternativeNames.length > 0 && (
                <p className="alternative-names">
                  Also known as: {culture.alternativeNames.join(', ')}
                </p>
              )}
              <p className="culture-overview">
                {culture.overview 
                  ? culture.overview.substring(0, 200) + '...'
                  : culture.description 
                    ? culture.description.substring(0, 200) + '...'
                    : 'Click to learn more about this culture.'}
              </p>
              {culture.language && (
                <div className="culture-language">
                  <strong>Language:</strong> {
                    typeof culture.language === 'string' 
                      ? culture.language 
                      : culture.language.name 
                        ? culture.language.name 
                        : culture.language.primary 
                          ? culture.language.primary 
                          : 'Multiple languages'
                  }
                </div>
              )}
              <div className="learn-more">
                Learn More →
              </div>
            </Link>
          ))
        ) : (
          <div className="no-results">
            <p>No cultures found matching your search.</p>
          </div>
        )}
      </div>

      {cultures.length === 0 && (
        <div className="empty-state">
          <h3>Cultural Information Coming Soon</h3>
          <p>We're working on adding comprehensive information about all South African cultures.</p>
        </div>
      )}
    </div>
  );
};

export default Cultures;
